<template>
	<div>
		<notifications />
		<section class="heading">
			<h1 class="title">Projects</h1>
			<router-link to="projects/create" class="btn btn-primary btn-lg">Add new Project</router-link>
		</section>
		<div class="table-responsive">
			<table class="table">
				<thead>
					<tr>
						<th>Name</th>
						<th>Description</th>
						<th></th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="item in projects.data" :key="item.id">
						<td>{{ item.name }}</td>
						<td>{{ item.description }}</td>
						<td>
							<div class="dropdown">
								<button class="btn btn-default dropdown-toggle" type="button" id="dropdownMenu1" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
									Action
									<span class="fa-stack">
										<i class="fa fa-circle-thin fa-stack-2x"></i>
										<i class="fa fa-caret-down fa-stack-1x"></i>
									</span>
								</button>
								<ul class="dropdown-menu" aria-labelledby="dropdownMenu1">
									<li><router-link :to="relativeUrl(`/projects/${item.id}/edit`)">Edit</router-link></li>
									<li><a href="#" @click="remove(item.id)">Delete</a></li>
								</ul>
							</div>
						</td>
					</tr>
					<tr colspan="3" v-if="projects.data.length <= 0">
						No data
					</tr>
				</tbody>
			</table>
		</div>
		<amy-pagination :pagination="projects"></amy-pagination>
	</div>
</template>

<script>
import AmyPagination from "../AmyPagination.vue";
import { getPage, relativeUrl } from "../../helpers";

export default {
	components: {
		AmyPagination,
	},
	data() {
		return {
			projects: {
				total: 0,
				per_page: 10,
				from: 1,
				to: 0,
				current_page: 1,
				data: [],
			},
			isLoading: false,
		}
	},
	beforeMount() {
		this.getProjects();
	},
	beforeRouteUpdate(to, from, next) {
		this.getProjects(to);
		next();
	},
	methods: {
		async remove(id) {
			this.isLoading = true;

			try {
				const response = await axios.delete(`/projects/${id}`);
				this.getProjects();
				this.$notify({
					type: 'success',
					title: 'Project Deleted!',
					text: 'You\'ve deleted the project!'
				})
			} catch {
				this.$notify({
					type: 'error',
					title: 'Oops!',
					text: 'Sorry, an error occured!'
				})
			}

			this.isLoading = false;
		},
		async getProjects(route = this.$route) {
			this.isLoading = true;

			try {
				const response = await axios.get(`/projects?page=${getPage(route)}`);
				this.projects = { ...response.data };
			} catch {
				this.$notify({
					type: 'error',
					title: 'Oops!',
					text: 'Sorry, an error occured!'
				})
			}

			this.isLoading = false;
		},
		relativeUrl
	}
}
</script>
